export enum InputType{
    Text = 1 ,
    Password = 2,
    Email = 3,
    Number = 4,
    EID=5
  }